export const locale = {
  lang: "en-CA",
  data: {
    PROCESSES: {
      ONGOING_PROCESS: "Ongoing process ...",
      DISMISS: "Dismiss",
    },
  },
};
